import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { C } from "../tokens";
import { QUOTE_HREF, BRAND } from "../data/company";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const location        = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const links = [
    { label: "Plans",        to: "/plans"        },
    { label: "About",        to: "/about"        },
    { label: "Our Team",     to: "/team"         },
    { label: "Testimonials", to: "/testimonials" },
    { label: "Contact",      to: "/contact"      },
  ];

  return (
    <>
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 900,
        height: "76px", display: "flex", alignItems: "center",
        justifyContent: "space-between", padding: "0 5vw",
        background: "rgba(253,250,244,0.96)",
        backdropFilter: "blur(18px)",
        borderBottom: `1px solid ${C.border}`,
        boxShadow: `0 2px 40px rgba(74,10,10,0.08)`,
      }}>
        <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
          <img src="/images/lepaz-logo-nav.png" alt={BRAND} style={{ height: "44px", width: "auto", display: "block", filter: "none", transition: "filter 0.45s" }}/>
        </Link>

        <div className="desk-nav" style={{ display: "flex", alignItems: "center", gap: "36px" }}>
          {links.map(l => (
            <Link key={l.to} to={l.to} style={{
              fontFamily: "'Outfit',sans-serif", fontSize: "12px", fontWeight: 500,
              color: location.pathname === l.to ? C.crimson : C.inkMid,
              textDecoration: "none", letterSpacing: "1.5px", textTransform: "uppercase",
              position: "relative", paddingBottom: "3px",
            }}>
              {l.label}
              {location.pathname === l.to && (
                <span style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: "1.5px", background: C.gold, transformOrigin: "left", animation: "drawLine 0.3s ease both" }}/>
              )}
            </Link>
          ))}
          <a href={QUOTE_HREF} target="_blank" rel="noreferrer" data-hover style={{
            background: `linear-gradient(135deg,${C.deep},${C.light})`,
            color: C.gold, padding: "10px 26px",
            fontFamily: "'Outfit',sans-serif", fontSize: "11px", fontWeight: 600,
            textDecoration: "none", letterSpacing: "2px", textTransform: "uppercase",
            border: `1px solid ${C.gold}30`,
            transition: "all 0.3s",
          }}
            onMouseEnter={e => { e.currentTarget.style.background = C.gold; e.currentTarget.style.color = C.deep; }}
            onMouseLeave={e => { e.currentTarget.style.background = `linear-gradient(135deg,${C.deep},${C.light})`; e.currentTarget.style.color = C.gold; }}
          >Get a Quote</a>
        </div>

        <button className="mob-btn" onClick={() => setOpen(!open)} style={{ background: "none", border: "none", padding: "4px", flexDirection: "column", gap: "5px" }}>
          {[0,1,2].map(i => <div key={i} style={{ width:24, height:2, background: C.crimson, transition:"all 0.3s", transform: open&&i===0?"rotate(45deg) translate(5px,5px)":open&&i===2?"rotate(-45deg) translate(5px,-5px)":"none", opacity: open&&i===1?0:1 }}/>)}
        </button>
      </nav>

      {open && (
        <div style={{ position:"fixed", top:"76px", left:0, right:0, zIndex:890, background:"rgba(253,250,244,0.98)", backdropFilter:"blur(18px)", padding:"28px 5vw 40px", borderBottom:`3px solid ${C.crimson}`, display:"flex", flexDirection:"column" }}>
          {links.map(l => <Link key={l.to} to={l.to} style={{ fontFamily:"'Outfit',sans-serif", fontSize:"16px", fontWeight:500, color:C.deep, textDecoration:"none", letterSpacing:"1px", textTransform:"uppercase", padding:"16px 0", borderBottom:`1px solid ${C.border}` }}>{l.label}</Link>)}
          <a href={QUOTE_HREF} target="_blank" rel="noreferrer" style={{ marginTop:"20px", background:`linear-gradient(135deg,${C.deep},${C.light})`, color:C.gold, padding:"15px 0", textAlign:"center", fontFamily:"'Outfit',sans-serif", fontSize:"12px", fontWeight:600, textDecoration:"none", letterSpacing:"2.5px", textTransform:"uppercase" }}>Get a Quote</a>
        </div>
      )}
    </>
  );
}
